<template>
	<div>
		<el-card class="box-card">
			<el-form label-width="80px" :inline="true">
				<el-form-item label="充值状态:">
					<el-select v-model="listQuery.search.state" placeholder="请选择">
						<el-option label="全部" value=""></el-option>
						<el-option label="未审核" value="0"></el-option>
						<el-option label="审核通过" value="1"></el-option>
						<el-option label="审核失败" value="2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="订单号:">
					<el-input v-model="listQuery.search.order_num" placeholder=""></el-input>
				</el-form-item>
				<el-form-item label="充值时间:">
					<el-date-picker v-model="listQuery.search.start_time" type="date" placeholder="充值的开始日期">
					</el-date-picker>
					-
					<el-date-picker v-model="listQuery.search.end_time" type="date" placeholder="充值的结束日期">
					</el-date-picker>
				</el-form-item>
			</el-form>
			<el-button type="primary" icon="el-icon-search" @click="keySearch">搜索</el-button>
		</el-card>
		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<el-table-column type="expand">
					<template slot-scope="props">
						<el-form label-position="left" inline class="demo-table-expand">
							<el-form-item v-if="props.row.state == 2" label="失败原因:">
								<span>{{props.row.err_msg}}</span>
							</el-form-item>
						</el-form>
					</template>
				</el-table-column>
				<el-table-column prop="create_time" label="充值时间">
					<template slot-scope="{row}">
						<span>{{ row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="money" label="充值金额"> </el-table-column>
				<el-table-column prop="order_num" label="订单号"> </el-table-column>
				<el-table-column prop="img" label="截图">
					<template slot-scope="{row}">
						<el-image v-if="row.img" style="width: 40px; height: 40px" :src="row.img" fit="fill"
							:preview-src-list="[row.img]">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column label="充值状态">
					<template slot-scope="{row}">
						<el-tag :type="row.state_color">
							{{ row.state_init}}
						</el-tag>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
		</div>
	</div>
</template>

<script>
	import {
		rechargeList
	} from '@/api/jd_task'
	import request from '@/tool/request'
	import {
		parseTime
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	import Dtp from '@/components/Ele/dateTimePicker.vue' // 时间选择组件
	export default {
		components: {
			Pagination,
			Dtp
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				data_list: [], // 表格数据
				loading: true,
				is_show_in1: false,
				in1_data: [],
				is_show_in2: false,
				in2_data: [],
				is_show_collocation: false,
				collocation_data: [],
				platform_list: [],
				state_all: [],
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData()
			this.getList()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},
			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						state: '',
						order_num: '',
						start_time: '',
						end_time: '',
					},
				}
			},
			getList() { // 获取列表数据
				this.loading = true;
				rechargeList(Qs.stringify(this.listQuery)).then(response => {
					this.data_list = response.result.items;
					this.total = response.result.total;
					this.loading = false;
				})
			},
			platformChange() {
				this.keySearch();
			},
			stateChange() {
				this.keySearch();
			}
		}
	}
</script>
<style>
	.el-radio {
		margin-right: 0px;
	}
</style>
